import ExampleView from '../../playground/ExampleView';
export { default as ExampleCode } from './ExampleCode';
export { default as ExampleFunctionBar } from './ExampleFunctionBar';
export { default as ExampleConsole } from './ExampleConsole';

export default ExampleView;
export function getCode(path) {
    return require(`!raw-loader!./${path}`).default.trim().replace(/\.\.\/\.\.\/components/, 'luna-orbit');
};